import React from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { Button, FormLabel, Textarea, requiredField } from '@offerzen/pinata-shame'
import { useSelector } from 'react-redux'

import ControlledHookField from '@/CandidateExperience/components/ControlledHookField'
import { userRole } from '@/CandidateExperience/selectors/currentUser'
import { UserRole } from '@/CandidateExperience/helpers/constants'

import styles from './styles'

const validators = {
  required: requiredField(),
}

const ApplyForm = ({ handleApply, companyName, isMatchForJobRequirements }) => {
  const { control, handleSubmit } = useForm()
  const loggedInUserRole = useSelector(userRole)

  return (
    <form onSubmit={handleSubmit(handleApply)}>
      <FormLabel
        label={
          <>
            Message<span aria-hidden>*</span>
          </>
        }
        htmlFor="message"
      />
      <ControlledHookField
        id="message"
        name="message"
        control={control}
        component={Textarea}
        validate={validators.required}
        aria-required
        className={styles.textarea}
        placeholder={
          !isMatchForJobRequirements && "Here's why I'd be a valuable addition to the team, even if I don't check all the boxes."
        }
        disabled={loggedInUserRole === UserRole.Admin}
        helpText={
          isMatchForJobRequirements
            ? `Let ${companyName} know why you're interested.`
            : "Don't match all the requirements? Explain why you're still a great fit."
        }
        autosize
      />

      <Button label="Apply" size="medium" type="submit" className={styles.button} disabled={loggedInUserRole === UserRole.Admin} />
    </form>
  )
}

ApplyForm.propTypes = {
  isMatchForJobRequirements: PropTypes.bool,
  handleApply: PropTypes.func.isRequired,
  companyName: PropTypes.string.isRequired,
}

export default ApplyForm
